import {ScrollView} from 'react-native-gesture-handler';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex: 1;
`;

export const Content = styled.View`
  flex: 1;
  padding: 0 24px;
  background-color: ${({theme}) => theme.colors.background};
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  margin-top: -${RFValue(20)}px;
  padding-top: ${RFValue(20)}px;
`;

export const HelpArticleList = styled(ScrollView)`
  margin: 0 -24px;
  margin-top: ${RFValue(12)}px;
`;
